<template>
	<div class="login">
		<div class="logo">
			<!-- <img src="../assets/img/logo.png" alt="efocus"> -->
		</div>
		<div class="form-wrap">

			<div class="form-login">
				<!-- <p class="main-title">LLI</p> -->
				<form class="form" :class="{ error: error }" @submit.prevent="submit_login()">
					<p class="title">Connexion</p>
					<div class="line">
						<label for="login" class="label">Email</label>
						<input type="login" class="input" id="login" v-model="login" ref="autofocus">
					</div>
					<div class="line">
						<label for="password" class="label">Mot de passe</label>
						<input :type="view_password ? 'text' : 'password' " class="input" id="password" v-model="password">
						<span  @click="view_password = !view_password">
							<icon  class="main-icon" :file="view_password ? 'eye-off' : 'eye'" :size="16"/>
						</span>
						
					</div>
					<div class="line">
						<div class="stay-connected" @click="stay_connected = !stay_connected">
							<div class="checkbox" :class="{ checked: stay_connected }"></div>
							<span class="text">Rester connecté sur cet ordinateur</span>
						</div>
					</div>
					<div class="line">
						<p class="error">{{ user.error_message }}</p>
					</div>
					<div class="buttons">
						<button type="submit" class="button">
							<span v-show="!app.loading">Connexion</span>
							<icon file="loader" v-show="app.loading" :size="24" />
						</button>
					</div>
				</form>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { Bus } from "@/Bus";

export default {
	name: "Login",
	data: function () {
		return {
			error: false,
			login: localStorage.getItem("lli-user") || "",
			password: "",
			stay_connected: true,
			view_password: false,
			env: process.env.VUE_APP_ENVIRONMENT,
			nodeenv: process.env.NODE_ENV,
			mavar: process.env.VUE_APP_VAR
		};
	},
	computed: {
		...mapGetters([ "app", "user" ]),
	},
	watch: {
		"user.last_call": function (newValue) {
			if (newValue) {
				const that = this;
				this.error = true;
				setTimeout(function () {
					that.error = false;
				}, 500);
			}
		}
	},
	methods: {
		submit_login: function () {
			if (!this.app.loading) {

				this.$store.dispatch("login", {
					login: this.login,
					password: this.password,
					stay_connected: this.stay_connected,
					// callback: function() {
					// 	Bus.$emit('logged')
					// }
				});
			}
		},
	},
	mounted: function () {
		this.$store.dispatch("set_loading", {loading: false});
		const that = this;

		this.$nextTick(function () {
			this.$refs.autofocus.focus();
		});

		Bus.$on("login-error", function () {
			that.error = true;
			setTimeout(function () {
				that.error = false;
			}, 500);
		});

	}
};
</script>

<style lang="stylus" scoped>
@import '../assets/css/app'
@import '../assets/css/grid'


.login
	height 100%
	background url(../assets/img/bg.jpg) center center no-repeat
	background-size cover
	color #333
	&.bg
		position absolute
		left 0
		top 0
		width 100%
		height 100%
	.logo
		position absolute
		left 16px
		top 16px
		height 40px
		img
			height 100%
	.form-wrap
		position absolute
		left 50%
		top 0
		height 100%
		// transform translate(-50%, -50%)
		// perspective 1000px
		.form-login
			position absolute
			left 50%
			top 50%
			transform translate(-50%, -50%)
			.main-title
				position absolute
				left 50%
				top -48px
				transform translateX(-50%)
				font-weight 500
				text-transform uppercase
				font-size 3.0rem
				color lighten(dark, 5%)
				color light
				// text-shadow 0 0 16px #999
				text-shadow -1px -1px #666
				white-space nowrap
			.form
				width 320px
				padding 32px
				background light
				border-radius radius
				transform-origin center center
				box-shadow 0 0 24px alpha(#000, 50%)
				&.error
					animation shake 0.25s infinite
				.title
					display block
					margin 0 0 24px 0
					font-weight 500
					font-size 1.6rem
					// text-transform uppercase
				.line
					margin 0 0 16px 0
					.label
						display block
						margin 0 0 2px 0
						color #666
						text-transform uppercase
						font-size 1.1rem
						font-weight 500
					.input
						display block
						width 100%
						height 48px
						padding 0 16px
						background #fff
						border 2px solid darken(light, 10%)
						border-radius radius
						font inherit
						color #333
						outline none
						&:focus
							border-color main_color
					textarea.input
						height auto
						padding 16px
						line-height 16px
					p.error
						color red
				.stay-connected
					font-size 1.2rem
					text-align left
					line-height 16px
					color #666
					cursor pointer
					&:hover
						.checkbox
							border-color darken(light, 20%)
					.checkbox
						float left
						width 16px
						height 16px
						background #fff
						border-radius (radius / 2)
						border 2px solid darken(light, 10%)
						&.checked
							border-color main_color
							background-size 10px 10px
							&:before
								content ''
								position absolute
								left 2px
								top 2px
								right 2px
								bottom 2px
								background-color main_color
								border-radius (radius / 2)
					.text
						display block
						margin-left 22px
				.buttons
					text-align right
					.required
						position absolute
						left 0
						bottom 0
						color #999
						font-size 1.2rem
						font-weight 400
					.button
						border none
						height 48px
						min-width 64px
						padding 0 16px
						border-radius radius
						background main_color
						border none
						cursor pointer
						font inherit
						font-weight 500
						text-transform uppercase
						font-size 1.2rem
						color #fff
						outline none
						&:hover
							background-color darken(main_color, 10%)
						&:active
							background-color darken(main_color, 20%)
							transform translateY(1px)
						&.left
							float left
						&.gray
							background-color darken(light, 25%)
							&:hover
								background-color darken(light, 30%)
							&:active
								background-color darken(light, 35%)
						.icon
							position absolute
							left 50%
							top 50%
							margin-left -12px
							margin-top -12px
							animation 1s rotate infinite linear
							
@keyframes shake
	0%
		transform translate(2px, 0) rotate(0deg)
	10%
		transform translate(-1px, 0) rotate(-1deg)
	20%
		transform translate(-3px, 0) rotate(1deg)
	30%
		transform translate(0px, 0) rotate(0deg)
	40%
		transform translate(1px, 0) rotate(1deg)
	50%
		transform translate(-1px, 0) rotate(-1deg)
	60%
		transform translate(-3px, 0) rotate(0deg)
	70%
		transform translate(2px, 0) rotate(-1deg)
	80%
		transform translate(-1px, 0) rotate(1deg)
	90%
		transform translate(2px, 0) rotate(0deg)
	100%
		transform translate(1px, 0) rotate(-1deg)


@media screen and (max-width: 400px)
	
	.login
		.logo
			display none
		.form-wrap
			.form-login
				.main-title
					font-size 2.0rem
					top -32px
				.form
					width 280px

</style>
